import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SalesInvoiceLine, SalesInvoiceLineCreate, SalesInvoiceLineFilter } from '../data/salesInvoiceLine';

export function createSalesInvoiceLineService(client: AxiosInstance) {
  return createCrudService<SalesInvoiceLine, SalesInvoiceLineCreate, SalesInvoiceLineFilter>(
    client,
    '/sales/SalesInvoiceLine',
    'id',
  );
}

export type SalesInvoiceLineService = CrudService<SalesInvoiceLine, SalesInvoiceLineCreate, SalesInvoiceLineFilter>;
